var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF2F4",
    d: "M8.833 15.5a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.593-.24h5V2.167h-5a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594Q8 .98 8.24.74 8.48.5 8.833.5h5q.688 0 1.177.49.49.489.49 1.177v11.666q0 .688-.49 1.177-.489.49-1.177.49zm-1.52-6.667h-5.98a.8.8 0 0 1-.593-.24A.8.8 0 0 1 .5 8q0-.354.24-.594t.593-.24h5.98L5.75 5.605a.77.77 0 0 1-.23-.562q0-.334.23-.584a.8.8 0 0 1 .583-.26.79.79 0 0 1 .604.24l2.98 2.979a.8.8 0 0 1 .25.583.8.8 0 0 1-.25.583l-2.98 2.98a.78.78 0 0 1-.593.24.85.85 0 0 1-.594-.261.8.8 0 0 1-.219-.594.81.81 0 0 1 .24-.573z"
  })));
};
export default SvgLogin;